import { render, staticRenderFns } from "./LinkPerson.vue?vue&type=template&id=c88a2308&scoped=true&"
import script from "./LinkPerson.vue?vue&type=script&lang=js&"
export * from "./LinkPerson.vue?vue&type=script&lang=js&"
import style0 from "./LinkPerson.vue?vue&type=style&index=0&id=c88a2308&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88a2308",
  null
  
)

export default component.exports